/**
 * Listado de breakpoints.
 */
export const BREAKPOINTS = {
	PORTRAIT: 768,
	LANDSCAPE: 1024,
	DESKTOP: 1280,
	HD: 1600,
	FULL_HD: 1820,
};
